import { SKY_CHAPTERS } from './78-sky-combat.mjs';

const NORMAL = Object.freeze({
  members: 4,
  speedMultiplier: 1,
  hp: null,
  aggression: null,
  attackPattern: null,
  rowDepth: 0,
});
const SWARM = Object.freeze({
  members: 8,
  speedMultiplier: 1.3,
  hp: 0.8,
  aggression: 1,
  attackPattern: 'aimed',
  rowDepth: 18,
});
const opening = (stage) => ['sky-01-dragon', 'sky-02-gilded-leviathan'].includes(stage?.id);

/** Authored opening-stage contrast, never a display-quality adjustment. Waves
 *2/5 double the craft at1.3× their class's travel speed;0.8HP needs1–2 base
 * cannon body contacts at any legal range. One aimed volley per craft retains
 * the existing0.65s physical charge without doubling paired/fan pressure.
 * Returned objects are immutable; invalid wave indices fail closed with null. */
export function skyJourneyWavePolicy(stage, index) {
  const count = stage?.kind === 'bonus' ? 0 : stage?.kind === 'rush' ? 1 : SKY_CHAPTERS.length;
  if (!Number.isInteger(index) || index < 0 || index >= count) return null;
  return opening(stage) && [1, 4].includes(index) ? SWARM : NORMAL;
}

/** Required original member counts are the kill-gate authority. Positive wave
 * counts alone do not grant rewards; each real squad still settles its own IDs.
 * Legacy/rush/bonus and dormant Cathedral descriptors keep their prior sizes. */
export function skyJourneyMemberCounts(stage) {
  const count = stage?.kind === 'bonus' ? 0 : stage?.kind === 'rush' ? 1 : SKY_CHAPTERS.length;
  return Array.from({ length: count }, (_, index) => skyJourneyWavePolicy(stage, index).members);
}
